// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I6fZd9Zgc6_eCGTG0W3y{padding-block:8px;padding-right:12px;align-items:center}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/ui/IntegrationIntercomConnectInbox/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,kBAAA,CACA,kBAAA","sourcesContent":[".selectInboxesDropdown {\n  padding-block: 8px;\n  padding-right: 12px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectInboxesDropdown": `I6fZd9Zgc6_eCGTG0W3y`
};
export default ___CSS_LOADER_EXPORT___;
